import { Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './messages';

export type MessageType = string | React.ReactNode | JSX.Element;

export interface MessageProps {
  definedMessage?: { defaultMessage: string; id: string };
  message?: MessageType;
  values?: { [key: string]: string };
}

export const Message: FC<MessageProps> = ({ definedMessage, message, values }) => {
  let content: React.ReactNode = <FormattedMessage {...messages.default} />;

  if (definedMessage) {
    content = <FormattedMessage {...definedMessage} values={values} />;
  }

  if (message) {
    content = <>{message}</>;
  }

  return <Typography variant="body2">{content}</Typography>;
};
